// extracted by mini-css-extract-plugin
export default {"iconHover":"Header_iconHover__9SdGl","dropDownText":"Header_dropDownText__8m4Ey"};